import { Trans } from '@lingui/react/macro';
import { Box, Button, ScrollArea } from '@pocketlaw/tetris';
import { ApprovalCheckError } from './ApprovalCheckError';
import { useApprovalCheck } from './ApprovalCheckProvider';
import { RerunCheckButton } from './RerunCheckButton';
import { SelectVoluntaryApprovers } from './SelectVoluntaryApprovers';
import { AdvancedApprovalCheckPreview } from '../../../AdvancedApprovalCheckPreview';
import { ActionsFooter, Content, Container, InnerContent } from './styled';
export function ReviewState() {
    const { response, resetCheck } = useApprovalCheck();
    const { summary, isApprovalRequired, approvers } = response;
    const handleCancel = () => {
        resetCheck();
    };
    return (<Container>
      <Content>
        <ScrollArea>
          <InnerContent>
            <ApprovalCheckError />

            <AdvancedApprovalCheckPreview isApprovalRequired={isApprovalRequired} summary={summary} approvers={approvers}/>
          </InnerContent>
        </ScrollArea>
      </Content>

      <ActionsFooter>
        <Box flexDirection="column" gap="md">
          <SelectVoluntaryApprovers />
          <Box gap="md">
            <Button $stretch appearance="secondary" size="small" onClick={handleCancel}>
              <Trans comment="Document approval check - Cancel button label">Cancel</Trans>
            </Button>
            <RerunCheckButton />
          </Box>
        </Box>
      </ActionsFooter>
    </Container>);
}
